import { render, staticRenderFns } from "./work-list-import.vue?vue&type=template&id=607026a3&scoped=true"
import script from "./work-list-import.vue?vue&type=script&lang=ts"
export * from "./work-list-import.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607026a3",
  null
  
)

export default component.exports